import { duration } from 'moment';
import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarRef, TextOnlySnackBar } from '@angular/material/snack-bar';
import { LocalStorageKeys } from '../misc/shared.constant';

// TODO: remove before merging — local test override
// const TEST_MODE = { enabled: true, duration: 3000 };

@Injectable({
    providedIn: 'root'
})
export class SnackbarService {
    FALLBACK_DURATION = 3000; // Fallback duration in milliseconds

    constructor(private matSnackBar: MatSnackBar) { }

    showErrorSnackbar(params: ToastParams): MatSnackBarRef<TextOnlySnackBar> {
        return this.open({ panelClass: ['snackbar-error'], ...params });
    }

    showRedErrorSnackbar(params: ToastParams): MatSnackBarRef<TextOnlySnackBar> {
        return this.open({ panelClass: ['red-snackbar'], ...params });
    }

    showSuccessSnackbar(params: ToastParams): MatSnackBarRef<TextOnlySnackBar> {
        return this.open({ panelClass: ['snackbar-success'], ...params });
    }

    showInfoSnackbar(params: ToastParams): MatSnackBarRef<TextOnlySnackBar> {
        return this.open({ panelClass: ['blue-snackbar'], ...params });
    }

    /**
     * Shows a warning snackbar with an orange background. Duration is determined by auto-dismiss settings or test mode override,
     * but can be overridden by passing a duration in the params.
     * @param params
     * @returns
     */
    showWarningSnackbar(params: ToastParams): MatSnackBarRef<TextOnlySnackBar> {
        return this.open({ panelClass: ['orange-snackbar'], ...params });
    }

    showSnackbar(params: ToastParams): MatSnackBarRef<TextOnlySnackBar> {
        return this.open(params);
    }


    private open(params: ToastParams): MatSnackBarRef<TextOnlySnackBar> {
        const {
            message,
            dismissActionText = '✕',
            panelClass = [],
            horizontalPosition = 'right',
            verticalPosition = 'top'
        } = params;

        let  duration = this.resolveDuration();
        // In case duration is passed as part of params, it should override the resolved duration in case auto-dismiss is disabled or not In test mode
        //  if(!duration){
        //     duration=params?.duration || this.FALLBACK_DURATION;
        //  }
       this.matSnackBar.dismiss(); // Dismiss any currently open snackbars before showing a new one
        return this.matSnackBar.open(message, dismissActionText, {
            ...(duration && { duration }),
            horizontalPosition,
            verticalPosition,
            panelClass: Array.isArray(panelClass) ? panelClass : [panelClass]
        });
    }

    private resolveDuration(): number | null {
        // if (TEST_MODE.enabled) {
        //     return TEST_MODE.duration;
        // }

        const { autoDismissedEnabled, autoDismissedDuration } = this.getAutoDismissConfig();
        return autoDismissedEnabled ? autoDismissedDuration : null;
    }

    getAutoDismissConfig(): AutoDismissConfig {
        const autoDismissedEnabled = localStorage.getItem(LocalStorageKeys.AUTO_DISMISSED_ENABLED) === 'true';

        if (!autoDismissedEnabled) {
            return { autoDismissedEnabled: false, autoDismissedDuration: null };
        }

        const rawDuration = Number(localStorage.getItem(LocalStorageKeys.AUTO_DISMISSED_DURATION));
        const autoDismissedDuration = Number.isFinite(rawDuration) && rawDuration > 0 ? rawDuration : 4000;

        return { autoDismissedEnabled, autoDismissedDuration };
    }
}

export type ToastParams = {
    message: string;
    dismissActionText?: string;
    panelClass?: string | string[];
    horizontalPosition?: 'start' | 'center' | 'end' | 'left' | 'right';
    verticalPosition?: 'top' | 'bottom';
    duration?: number; // Optional override for duration in milliseconds
}

export interface AutoDismissConfig {
    autoDismissedEnabled: boolean;
    autoDismissedDuration: number | null;
}
